import { gql } from '@apollo/client'

export const CREATE_USER_SESSION = gql`
  mutation createUserSession {
    createUserSession {
      id
    }
  }
`

// Temporarily commented out - mutation doesn't exist in backend schema
// export const PING_CROSS_DOMAIN_SESSION = gql`
//   mutation pingCrossDomainSession {
//     pingCrossDomainSession {
//       success
//     }
//   }
// `

export const MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation MarkAllNotificationRead($user_id: Int!) {
    markAllNotificationsRead(user_id: $user_id)
  }
`

export const LOGOUT_CLEANUP = gql`
  mutation LogoutCleanup {
    logout_cleanup {
      id
    }
  }
`

export const POST_LOGIN_INIT = gql`
  mutation PostLoginInit {
    post_login_init {
      id
    }
  }
`
export const UPDATE_CONVERSATION_RESOLVED_ARCHIVED = gql`
  mutation UpdateConversationResolvedArchived(
    $conversationId: Int
    $resolved: Boolean
    $archived: Boolean
  ) {
    updateConversationResolvedArchived(
      conversation_id: $conversationId
      resolved: $resolved
      archived: $archived
    ) {
      id
      actioned
      archived
      category
      claimed_id
      created_at
      created_by_id
    }
  }
`
